import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { memedApi, MemedSyncStatus } from '@/api/memed';

export function useMemedIntegration() {
  const queryClient = useQueryClient();

  const { data: status, isLoading } = useQuery<MemedSyncStatus>({
    queryKey: ['memed', 'integration', 'status'],
    queryFn: () => memedApi.getIntegrationStatus(),
  });

  const linkMutation = useMutation({
    mutationFn: () => memedApi.linkDoctor(),
    onSuccess: (data) => {
      if (data.success) {
        queryClient.invalidateQueries({
          queryKey: ['memed', 'integration', 'status'],
        });
      }
    },
  });

  const syncMutation = useMutation<MemedSyncStatus>({
    mutationFn: () => memedApi.syncDoctor(),
    onSuccess: (data) => {
      queryClient.setQueryData(['memed', 'integration', 'status'], data);
    },
  });

  return {
    status,
    isLoading,
    link: linkMutation.mutate,
    sync: syncMutation.mutate,
    isLinking: linkMutation.isPending,
    isSyncing: syncMutation.isPending,
  };
}